"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyPendingIDSpecificOperation = void 0;
var react_1 = require("react");
var DittoContext_1 = require("../DittoContext");
function useLazyPendingIDSpecificOperation() {
    var _this = this;
    var _a = (0, DittoContext_1.useDittoContext)(), dittoHash = _a.dittoHash, isLazy = _a.isLazy, load = _a.load;
    var liveQueryRef = (0, react_1.useRef)();
    var subscriptionRef = (0, react_1.useRef)();
    var _b = (0, react_1.useState)(), ditto = _b[0], setDitto = _b[1];
    var _c = (0, react_1.useState)(), document = _c[0], setDocument = _c[1];
    var _d = (0, react_1.useState)(), collection = _d[0], setCollection = _d[1];
    var _e = (0, react_1.useState)(), event = _e[0], setEvent = _e[1];
    var createLiveQuery = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var nextDitto, nextCollection, pendingOperation;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isLazy) return [3, 2];
                    return [4, load(params.path)];
                case 1:
                    nextDitto = _a.sent();
                    return [3, 3];
                case 2:
                    nextDitto = params.path
                        ? dittoHash[params.path]
                        : Object.values(dittoHash)[0];
                    _a.label = 3;
                case 3:
                    if (nextDitto) {
                        nextCollection = nextDitto.store.collection(params.collection);
                        pendingOperation = nextCollection.findByID(params._id);
                        if (!params.localOnly) {
                            subscriptionRef.current = pendingOperation.subscribe();
                        }
                        liveQueryRef.current = pendingOperation.observeLocal(function (doc, e) {
                            setEvent(e);
                            setDocument(doc);
                        });
                        setDitto(nextDitto);
                        setCollection(nextCollection);
                    }
                    else {
                        return [2, Promise.reject(new Error("Could not load a Ditto instance".concat(params.path ? ' for path ' + params.path : '', ".").concat(!isLazy
                                ? ' Make sure your provider finished loading the instance before you call exec'
                                : '', ".")))];
                    }
                    return [2];
            }
        });
    }); };
    var exec = function (params) { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            (_a = liveQueryRef.current) === null || _a === void 0 ? void 0 : _a.stop();
            liveQueryRef.current = undefined;
            (_b = subscriptionRef.current) === null || _b === void 0 ? void 0 : _b.cancel();
            subscriptionRef.current = undefined;
            setDocument(undefined);
            setDitto(undefined);
            setEvent(undefined);
            setCollection(undefined);
            return [2, createLiveQuery(params)];
        });
    }); };
    (0, react_1.useEffect)(function () {
        return function () {
            var _a, _b;
            (_a = liveQueryRef.current) === null || _a === void 0 ? void 0 : _a.stop();
            (_b = subscriptionRef.current) === null || _b === void 0 ? void 0 : _b.cancel();
        };
    }, []);
    return {
        collection: collection,
        ditto: ditto,
        document: document,
        event: event,
        exec: exec,
        liveQuery: liveQueryRef.current,
        subscription: subscriptionRef.current,
    };
}
exports.useLazyPendingIDSpecificOperation = useLazyPendingIDSpecificOperation;
//# sourceMappingURL=useLazyPendingIDSpecificOperation.js.map